import { createAction, props } from '@ngrx/store';
import { ListableProduction } from 'src/app/models/farm/production_per_farm';
import { FarmPostActivity, PostActivity } from 'src/app/models/PostActivity.model';

export const loadActivities = createAction('[PostActivity] Load Activities');
export const loadActivitiesSuccess = createAction(
  '[PostActivity] Load Activities Success',
  props<{ activities: PostActivity[] }>()
);
export const loadActivitiesFailure = createAction(
  '[PostActivity] Load Activities Failure',
  props<{ error: any }>()
);

export const addActivity = createAction(
  '[PostActivity] Add PostActivity',
  props<{ activity: FarmPostActivity, production_list: Array<ListableProduction> }>()
);
export const addActivitySuccess = createAction(
  '[PostActivity] Add PostActivity Success',
  props<{ activity: PostActivity[] }>()
);
export const addActivityFailure = createAction(
  '[PostActivity] Add PostActivity Failure',
  props<{ error: any }>()
);

export const deleteActivity = createAction(
  '[PostActivity] Delete PostActivity',
  props<{ activity_id: number, id: number }>()
);
export const deleteActivitySuccess = createAction(
  '[PostActivity] Delete PostActivity Success',
  props<{ activityId: number, id: number }>()
);
export const deleteActivityFailure = createAction(
  '[PostActivity] Delete PostActivity Failure',
  props<{ error: any }>()
);